import Marquee from 'react-fast-marquee';

const brands = [
  'FFBT', 'FFTir', 'ISSF', 'Skeet Olympique', 'Trap', 'DTL', 'Compak Sporting',
  'Beretta', 'Browning', 'Krieghoff', 'Perazzi',
];

export default function TrustBand() {
  return (
    <section data-testid="trust-band" className="py-8 border-y border-white/5 bg-[#0D0D0D] relative overflow-hidden">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {brands.map((brand, i) => (
          <div key={i} className="mx-10 flex items-center">
            <span className="text-[#A0A0A0]/60 text-sm font-semibold tracking-widest uppercase font-['Poppins'] whitespace-nowrap hover:text-[#FF6B35] transition-colors duration-300">
              {brand}
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
